<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField, UmbracoFormFieldPreValue } from 'types/blocks';
import type { FormKitOptionsList } from '@formkit/inputs';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();

function handleSelectPreValues(fieldPreValues: UmbracoFormFieldPreValue[]): FormKitOptionsList {
  return fieldPreValues.map((item) => {
    return {
      value: item.value || '',
      label: item.caption || '', // Map caption to label
    };
  });
}
</script>

<template>
  <FormKit
    :options="handleSelectPreValues(field.preValues)"
    v-bind="getDefaultFormField(field)"
    type="radio"
    :validation-messages="{
      required: field.requiredErrorMessage || $t('FormMessages.General.Required'),
    }"
    :validation="field.required ? 'required' : ''"
    decorator-icon="circle"
  />
</template>
